class Symbol {
    constructor(x, y, fontSize, canvasHeight) {
        this.characters = 'アイあわ-れあわ-れむイゆだ-ねるイなぐさ-めるなぐさ-むイク、そだ-つ、そだ-てる、はぐく-む012345678ABCDEFGHIJKLMNOPQRSトウキョウゴシックぎょうしょたいひらぎのかくごしっくみんちょうゴシック';
        this.x = x;
        this.y = y;
        this.fontSize = fontSize;
        this.text = '';
        this.canvasHeight = canvasHeight;
    }

    draw(context, gradient) {
        this.text = this.characters.charAt(Math.floor(Math.random()*this.characters.length));
        context.fillStyle = gradient;
        context.fillText(this.text, this.x * this.fontSize, this.y * this.fontSize);
        if (this.y * this.fontSize > this.canvasHeight && Math.random() > 0.98){
            this.y = 0;
        } else {
            this.y += 0.8;
        }
    }
}

class Effect {
    constructor(canvas){
        this.canvas = canvas;
        this.ctx = canvas.getContext('2d');
        this.canvasWidth = canvas.width;
        this.canvasHeight = canvas.height;

        if (window.innerWidth <= 767) {
            this.fontSize = 15;
            this.columns = Math.floor(this.canvasWidth/this.fontSize * 1); 
            this.frameInterval = 60; 
            this.cellSize = 20; 
        } else {
            // DESKTOP : Paramètres normaux
            this.fontSize = 25;
            this.columns = Math.floor(this.canvasWidth/this.fontSize * 1.5);
            this.frameInterval = 50;
            this.cellSize = 20;
        }

        this.symbols = [];
        this.gradient = this.createGradient();
        this.#initialize();
        this.lastTime = 0;  // Ajout du timing
        
        // Paramètres de la grille
        this.rows = Math.floor(this.canvasHeight / this.cellSize);
        this.cols = Math.floor(this.canvasWidth / this.cellSize);
    }

    createGradient() {
        let gradient = this.ctx.createLinearGradient(0, 0, this.canvasHeight, this.canvasWidth);
        gradient.addColorStop(0.2, 'rgb(4, 23, 198)');
        gradient.addColorStop(0.4, 'rgb(124, 42, 231)');
        gradient.addColorStop(0.6, 'rgb(187, 49, 215)');
        gradient.addColorStop(0.8, 'rgb(250, 9, 218)');
        return gradient;
    }

    #initialize(){
        for (let i = 0; i < this.columns; i++){
            this.symbols[i] = new Symbol(i, 0, this.fontSize, this.canvasHeight);
        }
    }

    drawGrid() {
        this.ctx.save();
        this.ctx.strokeStyle = 'rgba(255, 0, 0, 0.15)';
        this.ctx.lineWidth = 0.8;
        this.ctx.globalAlpha = 0.06;
        
        // Dessiner les lignes verticales
        for (let c = 0; c <= this.cols; c++){
            this.ctx.beginPath();
            this.ctx.moveTo(this.cellSize * c, 0);
            this.ctx.lineTo(this.cellSize * c, this.canvasHeight);
            this.ctx.stroke();
        }
        
        // Dessiner les lignes horizontales
        for (let r = 0; r <= this.rows; r++){
            this.ctx.beginPath();
            this.ctx.moveTo(0, this.cellSize * r);
            this.ctx.lineTo(this.canvasWidth, this.cellSize * r);
            this.ctx.stroke();
        }
        
        this.ctx.restore();
    }

    animate(timestamp) {
        // Contrôle du timing
        const deltaTime = timestamp - this.lastTime;
        if (deltaTime < this.frameInterval) {
            requestAnimationFrame(this.animate.bind(this));
            return;
        }
        this.lastTime = timestamp;

        // Fond semi-transparent pour créer l'effet de fade
        this.ctx.fillStyle = 'rgba(0, 51, 0, 0.02)';
        this.ctx.fillRect(0, 0, this.canvasWidth, this.canvasHeight);
        
        // Dessiner la grille
        this.drawGrid();
        
        // Dessiner les symboles
        this.ctx.font = this.fontSize + 'px monospace';
        this.symbols.forEach(symbol => symbol.draw(this.ctx, this.gradient));
        
        requestAnimationFrame(this.animate.bind(this));
    }
}

// Initialiser les deux canvas quand le DOM est chargé
document.addEventListener('DOMContentLoaded', () => {
    const canvasA = document.getElementById('rainPatternA');
    const canvasB = document.getElementById('rainPatternB');
    
    if (canvasA && canvasB) {
        // ✅ MÊMES CONDITIONS que ASCII effect
        if (window.innerWidth <= 374) {
            // TRÈS PETIT MOBILE
            canvasA.width = window.innerWidth * 0.48;
            canvasA.height = window.innerHeight;
            
            canvasB.width = window.innerWidth * 0.52;
            canvasB.height = window.innerHeight;
        } else if (window.innerWidth <= 425) {
            // PETIT MOBILE
            canvasA.width = window.innerWidth * 0.49;
            canvasA.height = window.innerHeight;
            
            canvasB.width = window.innerWidth * 0.51;
            canvasB.height = window.innerHeight;
        } else if (window.innerWidth > 425 && window.innerWidth <= 480) {
           
            canvasA.width = window.innerWidth * 0.47; 
            canvasA.height = window.innerHeight;
            
            canvasB.width = window.innerWidth * 0.53; 
            canvasB.height = window.innerHeight;
        } else if (window.innerWidth <= 767) {
            // MOBILE NORMAL (768px et moins)
            canvasA.width = window.innerWidth * 0.5;
            canvasA.height = window.innerHeight;
            
            canvasB.width = window.innerWidth * 0.55;
            canvasB.height = window.innerHeight;
        } else {
            // DESKTOP (768px et plus) - Disposition normale
            canvasA.width = window.innerWidth / 4;    // 25vw
            canvasA.height = window.innerHeight;
            
            canvasB.width = window.innerWidth / 3;    // 33vw
            canvasB.height = window.innerHeight;
        }
        
        // Créer et démarrer les effets
        const effectA = new Effect(canvasA);
        const effectB = new Effect(canvasB);
        
        effectA.animate();
        effectB.animate();
        
        window.addEventListener('resize', () => {
            
            if (window.innerWidth <= 374) {
                canvasA.width = window.innerWidth * 0.48;
                canvasA.height = window.innerHeight;
                canvasB.width = window.innerWidth * 0.52;
                canvasB.height = window.innerHeight;
            } else if (window.innerWidth <= 425) {
                canvasA.width = window.innerWidth * 0.49;
                canvasA.height = window.innerHeight;
                canvasB.width = window.innerWidth * 0.51;
                canvasB.height = window.innerHeight;
            } else if (window.innerWidth > 425 && window.innerWidth <= 480) {
                // ✅ NOUVEAU : Breakpoint spécifique 425px-480px
                canvasA.width = window.innerWidth * 0.47;
                canvasA.height = window.innerHeight;
                canvasB.width = window.innerWidth * 0.53;
                canvasB.height = window.innerHeight;
            } else if (window.innerWidth <= 767) {
                canvasA.width = window.innerWidth * 0.5;
                canvasA.height = window.innerHeight;
                canvasB.width = window.innerWidth * 0.55;
                canvasB.height = window.innerHeight;
            } else {
                // DESKTOP
                canvasA.width = window.innerWidth / 4;
                canvasA.height = window.innerHeight;
                canvasB.width = window.innerWidth / 3;
                canvasB.height = window.innerHeight;
            }
            
            // Recréer les effets avec les nouvelles dimensions
            const effectA = new Effect(canvasA);
            const effectB = new Effect(canvasB);
            
            effectA.animate();
            effectB.animate();
        });
    }
});